<app-header></app-header>
<!-- ACTUAL CONTENT LOADED INTO ROUTER OUTLET -->
<section style="background-color: #e6effa;">
  <div class="center">
    <app-alert></app-alert>
  </div>
  <div style="font-size: small">
    <app-loading [loadingText]="'Loading ... Please wait'" [zIndex]="999"></app-loading>
  </div>
  <router-outlet></router-outlet>
  <!-- Timeout Modal -->
  <div bsModal #timeoutmodal="bs-modal" class="modal fade" [config]="{backdrop: 'static'}">
    <div class="modal-dialog" style="width: 500px; margin: 30px auto;">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close pull-right" (click)="timeoutmodal.hide()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">Session about to expire.</h4>
        </div>
        <br>
        <div class="modal-body">
          <div class="row" style="padding: 10px; text-align: center;">
            <p><strong>{{idleState}}</strong></p>
          </div>
        </div>
        <div class="modal-footer" style="text-align: center;">
          <button type="button" class="btn btn-sm btn-outline-dark" (click)="timeoutmodal.hide(); logout()">No -
            Logout
          </button>
          <button type="button" class="btn btn-sm btn-primary" (click)="timeoutmodal.hide(); reset()">Yes - Extend
            Session - Continue Working
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
<app-footer></app-footer>
